import React, { useEffect, useState } from "react";
import Spinner from "../../../components/Spinner";
import { RootState } from "../../../redux/rootReducers";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "../../../components/data/Pagination";
import paramsToObject from "../../../helpers/paramsToObject";
import FormSearch from "../../../components/forms/FormSearch";
import { ButtonSolid } from "../../../components/forms/Button";
import PageWrapper from "../../../components/layouts/PageWrapper";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { DataTableWrapper } from "../../../components/data/DataTable";
import { getRoomAsync } from "../../../redux/reducers/rooms/rooms.actions";
import Button from "../../../components/forms/ButtonEx";
import { BootstrapGrid } from "../../../components/layouts/BootstrapGrid";
import { InputWrapper } from "../../../components/forms/FormComponents";

const RoomsPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  
  const meta = useSelector((state: RootState) => state.room.meta)
  const isLoading = useSelector((state: RootState) => state.room.isLoading);
  const rooms = useSelector((state: RootState) => state.room.rooms);

  const [txtSearch , setTxtSearch] = useState<string>('');
  const [searchQuery, setSearchQuery] = useState<string>('');

  const populateData = () => {
    const params = paramsToObject(location.search);
    const pageNumber = parseInt(params && params.page ? params.page : 1);
    if (pageNumber && !isNaN(pageNumber)) {
      dispatch(getRoomAsync.request({ page: pageNumber }));
    } else {
      navigate(`/rooms`);
    }
  };

  useEffect(() => {
    populateData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, searchQuery]);

  const onChangeTxtSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTxtSearch(e.target.value);
  }

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setSearchQuery(txtSearch);
    }, 1000);
    return () => clearTimeout(timeoutId);
  }, [txtSearch]);

  const renderRoomList = () => {
    if (isLoading) {
      return (
        <tr>
          <td colSpan={6} className="tablewrapper--loading">
            <div className="tablewrapper--loading--caption">
              <Spinner size="small" />
              <span>Memuat data...</span>
            </div>
          </td>
        </tr>
      );
    }

    if (rooms.length > 0) {
      return rooms.map(room => {
        return (
          <tr key={room.id}>
            <td><Link to={`/building-management/rooms/${room.id}`}>{room.room_name}</Link></td>
            <td>{room.room_building}</td>
            <td>{room.room_floor}</td>
            <td>{room.room_capacity} orang</td>
          </tr>
        );
      })
    } else {
      return (
        <tr>
          <td colSpan={4}>No room data was found</td>
        </tr>
      );
    }
  }

  return (
    <PageWrapper>
      <BootstrapGrid>
        <div className="row">
          <div className="col-lg-12">
            <Button noBlock={true} href="/building-management/rooms/create" caption="Daftarkan Ruangan Baru" />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-8">
            <DataTableWrapper>
              <div className="tablewrapper--title">
                Cari Ruangan
              </div>
              <div className="tablewrapper--table">
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <InputWrapper disabled={isLoading} noSpace>
                          <div className="input--field no--label">
                            <input
                              type="text"
                              value={txtSearch}
                              disabled={isLoading}
                              onChange={onChangeTxtSearch}
                              placeholder="Masukan nama ruangan disini"
                            />
                          </div>
                        </InputWrapper>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </DataTableWrapper>
            <DataTableWrapper>
              <div className="tablewrapper--title">
                Daftar Ruangan
              </div>
              <div className="tablewrapper--table">
                <table>
                  <thead>
                    <tr>
                      <th>Nama</th>
                      <th>Gedung</th>
                      <th>Lantai</th>
                      <th>Kapasitas</th>
                    </tr>
                  </thead>
                  <tbody>
                    {renderRoomList()}
                  </tbody>
                </table>
              </div>
              <Pagination
                isLoading={isLoading}
                totalItem={meta.total}
                listPerPage={meta.per_page}
                currentIndex={meta.current_page}
                url='rooms?page='
              />
            </DataTableWrapper>
          </div>
          <div className="col-lg-4">
          </div>
        </div>
      </BootstrapGrid>
    </PageWrapper>
  );
}

export default RoomsPage;